import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import entryToLink from "./entryToLink";

function instagramPost(type: string, id: string) {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "https://www.instagram.com/embed.js";
  document.getElementsByTagName("head")[0].appendChild(script);

  const postType = type === "reel" ? "reel" : "p";
  return `<blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/${postType}/${id}/?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);">
			<div style="padding:16px;">
				<a href="https://www.instagram.com/${postType}/${id}/?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> 
					<div style=" display: flex; flex-direction: row; align-items: center;"> 
						<div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> 
						<div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> 
							<div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> 
							<div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div>
						</div>
					</div>
					<div style="padding: 19% 0;"></div> 
					<div style="display:block; height:50px; margin:0 auto 12px; width:50px;">
						<svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg>
					</div>
					<div style="padding-top: 8px;"> 
						<div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">View this post on Instagram</div>
					</div>
					<div style="padding: 12.5% 0;"></div> 
					<div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;">
						<div> 
							<div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> 
							<div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> 
							<div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div>
						</div>
						<div style="margin-left: 8px;"> 
							<div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> 
							<div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div>
						</div>
						<div style="margin-left: auto;"> 
							<div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> 
							<div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> 
							<div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div>
						</div>
					</div> 
					<div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> 
						<div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> 
						<div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div>
					</div>
				</a>
			</div>
		</blockquote>`;
}

function escapeHtml(str: string): string {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function renderInlineLinkShortcodes(html: string): string {
  // [link url="..." text="..." longtext="..."] — longtext is optional
  // Attribute order is flexible; &quot; is normalised because Contentful's
  // HTML renderer escapes quotes inside text nodes.
  return html.replace(/\[link\s+([^\]]+)\]/gi, (match, attrs) => {
    const normalised = attrs.replace(/&quot;/g, '"').replace(/&amp;/g, "&");

    const urlMatch = normalised.match(/url="([^"]*)"/i);
    const textMatch = normalised.match(/text="([^"]*)"/i);
    const longtextMatch = normalised.match(/longtext="([^"]*)"/i);

    if (!urlMatch || !textMatch) {
      return match; // leave malformed shortcode as-is
    }

    const rawUrl = urlMatch[1].trim();
    const isRelative = rawUrl.startsWith("/");
    let isValidUrl = isRelative;
    let hostname = "";

    if (!isRelative) {
      try {
        const parsed = new URL(rawUrl);
        isValidUrl =
          parsed.protocol === "http:" || parsed.protocol === "https:";
        hostname = parsed.hostname;
      } catch (_e) {
        isValidUrl = false;
      }
    }

    if (!isValidUrl) {
      return match; // reject unsafe / unparseable URLs
    }

    const text = escapeHtml(textMatch[1]);
    const longtext = longtextMatch ? escapeHtml(longtextMatch[1]) : null;
    const isExternal =
      !isRelative && !rawUrl.startsWith("https://www.curacao.com");
    const externalAttrs = isExternal
      ? ' target="_blank" rel="noopener noreferrer"'
      : "";
    const safeUrl = escapeHtml(rawUrl);
    const faviconSrc = hostname
      ? `https://www.google.com/s2/favicons?domain=${escapeHtml(
          hostname
        )}&sz=16`
      : "";

    const faviconImg = faviconSrc
      ? `<img class="richText__inlineLinkFavicon" src="${faviconSrc}" alt="" aria-hidden="true" />`
      : "";
    let cardHtml = "";
    if (longtext && hostname) {
      cardHtml =
        `<span class="richText__inlineLinkCard">` +
        `<span class="richText__inlineLinkCard__header">` +
        `<img src="${faviconSrc}" alt="" aria-hidden="true" />` +
        escapeHtml(hostname) +
        `</span>` +
        `<span class="richText__inlineLinkCard__body">` +
        `<span class="richText__inlineLinkCard__body-header">${text}</span><br />` +
        `${longtext}</span>` +
        `</span>`;
      // return `<span class="richText__inlineLinkWrap">${chipHtml}${cardHtml}</span>`;
    }

    const chipHtml = `<a class="richText__inlineLink" href="${safeUrl}"${externalAttrs}>${faviconImg}<span class="richText__inlineLinkLabel">${text}</span>${cardHtml}</a>`;

    return `<span class="richText__inlineLinkWrap">${chipHtml}</span>`;
  });
}

function renderButtonShortcode(shortcode: string) {
  const textMatch = shortcode.match(/text="([\s\S]*?)"/i);
  const linkMatch = shortcode.match(/link="([\s\S]*?)"/i);

  if (!textMatch || !linkMatch) {
    return null;
  }

  const text = textMatch[1].replace(/\\n|\n/g, "<br />");
  const link = linkMatch[1].trim();
  const isInternalLink =
    link.startsWith("https://www.curacao.com") || link.startsWith("/");

  return `<a class="richText__link richText__buttonLink -white" href="${link}"${
    isInternalLink ? "" : ' target="_blank"'
  }>${text}</a>`;
}

export const options = {
  renderNode: {
    [INLINES.EMBEDDED_ENTRY]: (node: any, next: any) => {
      const linkData = entryToLink(node.data.target, "en");
      return `<span class="richText__link" role="link" link="${linkData.link}">${linkData.title}</span>`;
    },
    [BLOCKS.EMBEDDED_ASSET]: (node: any, next: any) => {
      return `<img class="richText__image" src="${node.data.target.fields.file.url}" alt="${node.data.target.fields.title}" />`;
    },
    [INLINES.HYPERLINK]: (node: any, next: any) => {
      return `<a class="richText__link" href="${node.data.uri}"${
        node.data.uri.startsWith("https://www.curacao.com") ||
        node.data.uri.startsWith("/")
          ? ""
          : ' target="_blank" rel="noopener noreferrer"'
      }>${next(node.content)}</a>`;
    },

    [BLOCKS.PARAGRAPH]: (node: any, next: any) => {
      const paragraphText = node.content[0] && node.content[0].value;

      if (
        paragraphText.match(
          // eslint-disable-next-line
          /(\[YouTube)(.[A-Za-z0-9_\-]*)(.[A-Za-z0-9_\-]*)(\])/gi
        )
      ) {
        const strParts = paragraphText
          // eslint-disable-next-line
          .replace(/[\[\]]/g, "")
          .split(" ");
        const anchor = strParts[2]
          ? `<a name=${strParts[2]} id=${strParts[2]}></a>`
          : "";
        let item = "";
        switch (strParts[0]) {
          case "youtube":
          case "Youtube":
          case "YouTube":
            item = `<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/${strParts[1]}" 
              frameborder="0" 
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen>
            </iframe>`;
            break;
        }
        return `<div class='youTubeVideo'>${anchor}${item}</div>`;
      } else if (
        paragraphText.match(
          // eslint-disable-next-line
          /(\[instagram)(.[A-Za-z0-9_\-]*)(.[A-Za-z0-9_\-]*)(\])/gi
        )
      ) {
        const strParts = paragraphText
          // eslint-disable-next-line
          .replace(/[\[\]]/g, "")
          .split(" ");
        const anchor = strParts[2]
          ? `<a name=${strParts[2]} id=${strParts[2]}></a>`
          : "";
        const item = instagramPost("post", strParts[1]);
        return `<div class='instagramPost'>${anchor}${item}</div>`;
      } else if (
        paragraphText.match(
          // eslint-disable-next-line
          /(\[instagramreel)(.[A-Za-z0-9_\-]*)(.[A-Za-z0-9_\-]*)(\])/gi
        )
      ) {
        const strParts = paragraphText
          // eslint-disable-next-line
          .replace(/[\[\]]/g, "")
          .split(" ");
        const anchor = strParts[2]
          ? `<a name=${strParts[2]} id=${strParts[2]}></a>`
          : "";
        const item = instagramPost("reel", strParts[1]);
        return `<div class='instagramReel'>${anchor}${item}</div>`;
      } else if (paragraphText.match(/^\[button\s+[\s\S]*\]$/i)) {
        const item = renderButtonShortcode(paragraphText);
        return item ? `<p>${item}</p>` : `<p>${next(node.content)}</p>`;
      } else {
        const rendered = next(node.content);
        return `<p>${
          rendered.includes("[link ")
            ? renderInlineLinkShortcodes(rendered)
            : rendered
        }</p>`;
      }
    },
  },
};

const richHtml = (data: any, history: any) => {
  return {
    onClick: (e: any) => {
      e.stopPropagation();
      if (e.target.getAttribute("link")) {
        history.push(e.target.getAttribute("link"));
      }
    },
    dangerouslySetInnerHTML: { __html: documentToHtmlString(data, options) },
  };
};
export default richHtml;

// Plain HTML string version of the same rendering, for contexts (like
// JSON-LD answer text) that need the markup but not a click handler.
export const richTextToHtmlString = (data: any): string =>
  richHtml(data, null).dangerouslySetInnerHTML.__html.replace(
    /(\r\n|\n|\r)/g,
    "<br/>"
  );

// Plain-text version (tags stripped, entities decoded) for JSON-LD
// properties like `articleBody` that expect text rather than markup.
// Decodes `&amp;` first: some Contentful rich-text fields contain a
// literal "&nbsp;"/"&lt;" etc. typed as plain text (e.g. pasted from a
// word processor), which the renderer HTML-escapes to "&amp;nbsp;" etc.
// Decoding "&amp;" first unmasks that back to "&nbsp;" so the later
// passes can still turn it into a real space rather than leaving the
// literal entity text behind.
export const richTextToPlainText = (data: any): string =>
  richTextToHtmlString(data)
    .replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, " ")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/(p|div|h[1-6]|li)>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&amp;/g, "&")
    .replace(/&nbsp;/g, " ")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/[ \t]+/g, " ")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
